export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMy42ODgiIGhlaWdodD0iMjMuNjg4IiB2aWV3Qm94PSIwIDAgMjMuNjg4IDIzLjY4OCI+CiAgPGcgaWQ9IkNsb3NlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUzIDAuNTMpIj4KICAgIDxsaW5lIGlkPSJMaW5lXzIiIGRhdGEtbmFtZT0iTGluZSAyIiB4Mj0iMzIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMjIuNjI3KSByb3RhdGUoLTQ1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMjEzMzREIiBzdHJva2Utd2lkdGg9IjEuNSIvPgogICAgPGxpbmUgaWQ9IkxpbmVfMSIgZGF0YS1uYW1lPSJMaW5lIDEiIHgyPSIzMiIgdHJhbnNmb3JtPSJyb3RhdGUoNDUpIiBmaWxsPSJub25lIiBzdHJva2U9IiMyMTMzNEQiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./images/close.svg
// module id = 107
// module chunks = 0